let data = [];

module.exports = { data };
